/* istanbul ignore file */
export class Toggle {
  constructor(public id: string = '', public status: boolean = false) {}
}
